export default "__VITE_ASSET__DqhvlsqR__"